import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import EnterpriseComponent from "../../EnterpriseComponent";

/**
 * The realm's organisations, read through t1.
 *
 * NOT t6/v1/organizations, though that is where organisations are administered. Every read in t6's
 * Administration application is wrapped in @with_administration_privilege, so a chart drawn from it
 * answers for administrators and 403s for everybody else -- and this one opens from an Owner name
 * any user can see.
 *
 * t1/v1/positions returns them beside the positions when asked, which keeps this to one endpoint:
 * every path in t1 is hand-written gateway surface, three terraform files apiece, and a caller
 * drawing the chart wants both halves of it anyway.
 */

class OrganizationEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        AxiosFoundationAPI({
            method: "GET",
            url: "t1/v1/positions",
            json: true,
            params: {IncludeOrganizations: true, Limit: 1},
        }).then(response => {
            const rows = (response?.data?.Organizations ?? []).map(one => ({
                RowSelected: false,
                USID: one.USID,
                Name: one.Name,
                OrganizationType: one.OrganizationType,
                ParentUSID: one.ParentUSID,
                Status: one.Status,
                __operation: "query results",
            }));
            this.fetchEnterpriseComponentSuccess({Count: rows.length, Results: rows}, page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    // NO WRITE PATH: organisations are administered in t6 and nowhere else. This component exists
    // so a Foundation user can READ the tree behind an Owner name.
}

export default OrganizationEnterpriseComponent;